(function ($) {
    class W4D_FrontendHelper {
        constructor() {
            this.initSelectors();
            this.bindEvents();
            this.quickFixOrdersTableLayout(); // TEMPORARY SOLUTION
            this.initCartRefresh();
            this.qualizePortfolio2Heights();
            this.setupFocusTracking();
        }

        setupFocusTracking() {
            $(window).on('keydown', (e) => {
                if (e.key === 'Tab') this.lastInteractionWasKeyboard = true;
            });

            $(window).on('mousedown', () => {
                this.lastInteractionWasKeyboard = false;
            });

            // Only add the attribute for keyboard focus
            $(document).on('focus', 'input, textarea', (e) => {
                const $input = $(e.currentTarget);
                if (this.lastInteractionWasKeyboard) {
                    $input.attr('data-focus-source', 'keyboard');
                } else {
                    $input.removeAttr('data-focus-source');
                }
            });

            $(document).on('blur', 'input, textarea', (e) => {
                $(e.currentTarget).removeAttr('data-focus-source');
            });
        }

        qualizePortfolio2Heights() {
            if ($(window).width() > 768) {
                $('.portfolio-2__text h3, .portfolio-2__text p').height('auto');
                const $cards = $('.portfolio-2__card');

                if ($cards.length) {
                    let maxH3Height = 0;
                    $cards.find('.portfolio-2__text h3').each(function() {
                        maxH3Height = Math.max(maxH3Height, $(this).outerHeight());
                    });
                    $cards.find('.portfolio-2__text h3').height(maxH3Height);

                    let maxPHeight = 0;
                    $cards.find('.portfolio-2__text p').each(function() {
                        maxPHeight = Math.max(maxPHeight, $(this).outerHeight());
                    });
                    $cards.find('.portfolio-2__text p').height(maxPHeight);
                }
            } else {
                // Reset heights on mobile
                $('.portfolio-2__text h3, .portfolio-2__text p').height('auto');
            }
        }

        initCartRefresh() {
            $(window).on("pageshow", (e) => {
                if (e.originalEvent.persisted) {
                    this.updateCartAjax();
                }
            });
        }

        initSelectors() {
            this.productCard = ".product-card";
            this.contextMenuIcon = $(".icon-dots, .cl_ick");
            this.showcases = $(".tabs-showcase");
            this.tabs = $(".tabs-showcase__list-item");
            this.tabContents = $(".tabs-showcase__tab-content");
            this.headerCartIcon = $('#header_cart_icon');
        }

        bindEvents() {
            if ($('body').hasClass('page-template-template-landing')) {
                let resizeTimer2;
                $(window).on('resize', () => {
                    clearTimeout(resizeTimer2);
                    resizeTimer2 = setTimeout(() => {
                        this.qualizePortfolio2Heights();
                    }, 250);
                });
            }

            let resizeTimer;
            $(window).on("resize", () => {
                if (!$("body").hasClass("archive")) return;

                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => {
                    this.checkFilterOverflow();
                }, 150);
            });

            this.contextMenuIcon.on("click", (e) => {
                e.stopPropagation();
                e.preventDefault();

                // Close all other open context menus first
                $(".context-menu--open")
                    .not($(e.currentTarget).siblings(".context-menu"))
                    .removeClass("context-menu--open");

                this.openContextMenu(e);
            });

            // Also prevent propagation on the menu items
            $(".context-menu__item").on("click", (e) => {
                //e.stopPropagation();
                e.preventDefault();
            });

            // Close menu when clicking anywhere else on the document
            $(document).on("click", (e) => {
                if (
                    !$(e.target).closest(".context-menu").length &&
                    !$(e.target).hasClass("icon-dots")
                ) {
                    $(".context-menu--open").removeClass("context-menu--open");
                }
            });

            this.tabs.on('click', (e) => this.displayShowcaseBlockTabs(e));
        }

        displayShowcaseBlockTabs(e) {
            const $clickedTab = $(e.currentTarget);
            const index = $clickedTab.data("tab-index");
        
            this.tabs.removeClass("tabs-showcase__list-item--active").attr("aria-selected", "false");
        
            $clickedTab.addClass("tabs-showcase__list-item--active").attr("aria-selected", "true");
        
            this.tabContents.removeClass("tabs-showcase__tab-content--active").attr("aria-hidden", "true");
        
            this.tabContents.filter(`[data-tab-index="${index}"]`)
            .addClass("tabs-showcase__tab-content--active")
            .attr("aria-hidden", "false");
        }

        openContextMenu(e) {
            e.preventDefault();
            $(e.currentTarget)
                .siblings(".context-menu")
                .toggleClass("context-menu--open");
        }

        historyBack() {
            window.history.back();
        }

        quickFixOrdersTableLayout() {
            this.ordersTable = $(".woocommerce-orders-table");
            this.ordersTable.removeClass("shop_table_responsive");
        }

        getCurrentCategory() {
            const pathSegments = window.location.pathname.split("/");
            return pathSegments.filter((segment) => segment.length > 0).pop();
        }

        parseUrlParams() {
            let urlParams = new URLSearchParams(window.location.search);
            let filters = {};
            let sort = "default";
            let page = 1;

            for (let [key, value] of urlParams.entries()) {
                if (key.startsWith("pa_") || key === "stock_status" || key === "product_tag") {
                    filters[key] = value.split(",");
                } else if (key === "price") {
                    let [min, max] = value.split(",");
                    filters[key] = {
                        min: parseInt(min),
                        max: parseInt(max),
                    };
                } else if (key === "sort") {
                    sort = value;
                } else if (key === "page") {
                    page = parseInt(value);
                }
            }

            return { filters, sort, page };
        }

        checkFilterOverflow() {
            let filtersWrapper = $(".filters__wrapper");
            let expandButton = $(".filters__expand-btn");

            if (!filtersWrapper.length || !expandButton.length) return;

            let filterExpandAndClear = filtersWrapper.find(
                ".filters__expand-and-clear"
            )[0];
            let expandBtn = filterExpandAndClear.querySelector(
                ".filters__expand-btn"
            );
            let resetBtn = filterExpandAndClear.querySelector(".filters__reset-all");

            // Store original display value
            const originalDisplay = expandBtn.style.display;

            // Temporarily make visible to measure
            expandBtn.style.display = "block";
            expandBtn.style.visibility = "hidden";

            // Measure
            const controlsWidth = expandBtn.offsetWidth + resetBtn.offsetWidth;

            // Restore original state
            // console.log("Original Display: " + originalDisplay);
            expandBtn.style.display = originalDisplay;
            expandBtn.style.visibility = "";
            let beforeFadeOut = 44;

            let totalFiltersWidth = 0;
            filtersWrapper.children(".filter").each(function (index) {
                // console.log(`Filter ${index}:`, $(this));
                // console.log($(this)[0].clientWidth);
                // console.log(`Filter ${index} width:`, this.offsetWidth);
                // console.log(`Filter Bounding client Recct ${index} width:`, this.getBoundingClientRect().width);
                totalFiltersWidth += this.offsetWidth;
            });

            let filterWraperWidth = filtersWrapper[0].clientWidth;
            // console.log("Filter Wrapper Width: " + filterWraperWidth);

            let isOverflowing =
                totalFiltersWidth > filterWraperWidth - controlsWidth - beforeFadeOut;

            // console.log("Total filters width: " + totalFiltersWidth);
            // console.log("Controls width: " + controlsWidth);
            // console.log("Container width: " + filtersWrapper[0].clientWidth);
            // console.log("Is overflowing: " + isOverflowing);

            // If filters are not overflowing but some are selected,
            // add the expanded class if it's not already there

            // console.log(isOverflowing ? "OVERFLOWING YES" : "OVERFLOWING NO")
            expandButton.css("display", isOverflowing ? "block" : "none");

            const isWrapperExpanded = filtersWrapper[0].classList.contains(
                "filters__wrapper--expanded"
            );

            if (isWrapperExpanded) {
                // If wrapper is expanded, we must keep the expanded class
                filterExpandAndClear.classList.add(
                    "filters__expand-and-clear--expanded"
                );
            } else {
                // If wrapper is not expanded, toggle based on overflow
                filterExpandAndClear.classList.toggle(
                    "filters__expand-and-clear--expanded",
                    !isOverflowing
                );
            }
        }

        showNotice(
            type = "success",
            msg = "Postavke su uspješno spremnjene"
        ) {
            let className =
                type === "success" ? "w4d-notice--success" : "w4d-notice--error";
            let iconClass = type === "success" ? "icon-checkmark" : "icon-x-rounded";

            let noticeHtml =
            '<div class="w4d-notice ' + className +'">'+
                '<div class="flex g-16 align-items-center">' +
                    '<i class="w4d-notice__status-icon ' + iconClass +'"></i>'+
                    '<p class="w4d-notice__text">'+ msg +'</p>'+
                '</div>'+
                '<div class="w4d-notice__close-container">'+
                    '<i class="w4d-notice__close icon-x-rounded"></i>'+
                '</div>'+
            '</div>';

            // Append the notice to the DOM
            $("body").append(noticeHtml);

            // Remove the notice after 3 seconds
            setTimeout(() => {
                $(".w4d-notice").fadeOut(300, function () {
                    $(this).remove();
                });
            }, 3000);

            // Add click event to close the notice manually
            $(".w4d-notice__close-container").on("click", function () {
                $(this)
                    .closest(".w4d-notice")
                    .fadeOut(300, function () {
                        $(this).remove();
                    });
            });
        }

        setCookie(name, value, days, sameSite = "Lax", secure = false) {
            let expires = "";
            if (days !== null) {
                const date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                expires = `; expires=${date.toUTCString()}`;
            } else {
                const date = new Date();
                date.setFullYear(date.getFullYear() + 100);
                expires = `; expires=${date.toUTCString()}`;
            }
            const secureFlag = secure ? "; Secure" : "";
            document.cookie = `${name}=${
                value || ""
            }${expires}; path=/; SameSite=${sameSite}${secureFlag}`;
        }

        getCookie(name) {
            const nameEQ = `${name}=`;
            const cookies = document.cookie.split(";");

            for (let cookie of cookies) {
                cookie = cookie.trim();
                if (cookie.indexOf(nameEQ) === 0) {
                    return cookie.substring(nameEQ.length);
                }
            }
            return null;
        }

        updateCartIcon(cartCount) {
            this.headerCartIcon.attr("data-populated", cartCount);
            if (cartCount > 0) {
                this.headerCartIcon.addClass("w4d-header__btn--populated");
                this.headerCartIcon.removeClass("w4d-header__btn--adding");
                requestAnimationFrame(() => {
                    this.headerCartIcon.addClass("w4d-header__btn--adding");
                });

                // Remove the animation class when animation ends
                this.headerCartIcon.one("animationend", () => {
                    this.headerCartIcon.removeClass("w4d-header__btn--adding");
                });

            } else {
                this.headerCartIcon.removeClass("w4d-header__btn--populated");
            }
        }

        getQueryParameter(param) {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get(param);
        }

        updateCartAjax() {
            const ajaxData = {
                action: "w4d_get_cart_count",
                nonce: w4d_frontend_ajax.nonce
            };

            $.post({
                url: w4d_frontend_ajax.ajax_url,
                data: ajaxData,
            }).then((response) => {
                if (response.success) {
                    this.updateCartIcon(response.data.count);
                } else {
                    this.updateCartIcon(0);
                }
            });
        }
    }

    $(document).ready(() => {
        window.W4D_FrontendHelper = new W4D_FrontendHelper();
    });
})(jQuery);
